import { JSONSchemaType } from "ajv"
import validateConstant, {
  e入力パターン,
} from "../../../constant/validateConstant"
import util from "../../../ts/util"
import { TInvoiceHeaderMakePutReqValidate } from "./TInvoice"

export const TInvoiceHeaderMakePutReqSchema: JSONSchemaType<TInvoiceHeaderMakePutReqValidate> =
  {
    type: "object",
    properties: {
      荷主コード: {
        type: "string",
        minLength: 1,
        maxLength: validateConstant.LENGTH.荷主コード,
        pattern: validateConstant.PATTERN.英数字のみ,
        title: "荷主コード",
        errorMessage: util.stringErrorMessage("荷主コード", {
          required: true,
          maxLength: validateConstant.LENGTH.荷主コード,
          pattern: e入力パターン.英数字のみ,
        }),
      },
      荷主請求ID: {
        type: "number",
        title: "表紙名",
        nullable: false,
        errorMessage: util.stringErrorMessage("表紙名", {
          required: true,
        }),
      },
      フッター備考: {
        type: "string",
        maxLength: validateConstant.LENGTH.一般テキスト,
        title: "備考",
        errorMessage: util.stringErrorMessage("備考", {
          required: false,
          maxLength: validateConstant.LENGTH.一般テキスト,
        }),
      },
      請求処理状態区分コード: {
        type: "string",
        minLength: 1,
        maxLength: validateConstant.LENGTH.汎用区分コード,
        pattern: validateConstant.PATTERN.英数字のみ,
        title: "請求処理状態",
        errorMessage: util.stringErrorMessage("請求処理状態", {
          required: true,
          maxLength: validateConstant.LENGTH.汎用区分コード,
          pattern: e入力パターン.英数字のみ,
        }),
      },
    },
    required: ["荷主コード", "荷主請求ID", "請求処理状態区分コード"],
    errorMessage: {
      required: util.JsonSchemeRequiredErrorMessages([
        "荷主コード",
        "荷主請求ID",
        "請求処理状態区分コード",
      ]),
    },
  }
